export class Verifyotp {
    pass1:string;
    pass2:string;
    pass3:string;
    pass4:string;
    pass5:string;
    pass6:string;
    auth_token:string;
}
